import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
//import 'bootstrap/dist/css/bootstrap.min.css';

//import "primeicons/primeicons.css";
import { PrimeReactProvider } from "primereact/api";
import "primeflex/primeflex.css";
//import "primereact/resources/primereact.css";
//import "primereact/resources/themes/lara-light-cyan/theme.css";

 import 'primereact/resources/themes/lara-light-cyan/theme.css'; // O el tema que prefieras
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import "./index.css"; // Para estilos personalizados
//import "./Login.css"; // Para estilos personalizados
ReactDOM.render(
  <React.StrictMode>
    <PrimeReactProvider>
      <App />
    </PrimeReactProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
